<template>
    <div class="p-8 sm:p-0">
        <vue-player-video class="z-0" :src="asset('media/1-million-pound-jackpot.mp4')" colors="#fceb0d" />
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import VuePlayerVideo from 'vue3-player-video'

export default {
    components: {
        TwCard,
        VuePlayerVideo,
    },

    setup(props) {
    }
}

</script>